// project import
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import { useGiraf } from 'giraf/index';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { gHead } = useGiraf();
  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Navigation />
      {!gHead.IsSuperAdmin && <NavCard />}
    </SimpleBar>
  );
};

export default DrawerContent;
